import { setFocus } from '/helpers/misc'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Component: `.modal`
 * Used to contain modal content
 *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $html = document.querySelector('html')
const $modal = document.querySelector('.modal')
const $body = document.querySelector('.modal .body')
const $modalClose = document.querySelector('.modal .close')
const $menuToggle = document.querySelector('.header .main-menu .icon')
const $searchToggle = document.querySelector('.header .search .icon')

export default {

	$modal,

	$body,

	open(options) {
		options = options || {}

		$html.classList.add('no-page-scroll')
		$html.classList.remove('header-up')
		$modal.classList.add('open')
		if (options.classes) {
			_.each(options.classes, className => $modal.classList.add(className))
		}
		$modal.removeAttribute('aria-hidden')
		$modalClose.setAttribute('role', 'button')
		$modalClose.setAttribute('tabindex', '0')

		setFocus($modal)

		const closeHandler = function(event) {
			event.preventDefault()

			$html.classList.remove('no-page-scroll')
			$modal.classList.remove('open')
			if (options.classes) {
				_.each(options.classes, className => $modal.classList.remove(className))
			}
			$modal.setAttribute('aria-hidden', 'true')
			$modalClose.removeAttribute('role')
			$modalClose.removeAttribute('tabindex')

			if (options.onClose) {
				options.onClose(options.payload)
			}
			$modalClose.removeEventListener('click', closeHandler)
			$menuToggle.removeEventListener('click', closeHandler)
			$searchToggle.removeEventListener('click', closeHandler)
			if (options.backgroundClose) {
				$modal.removeEventListener('click', closeHandler)
			}
		}
		$modalClose.addEventListener('click', closeHandler)
		$menuToggle.addEventListener('click', closeHandler)
		$searchToggle.addEventListener('click', closeHandler)
		if (options.backgroundClose) {
			$modal.addEventListener('click', closeHandler)
		}
	},

}
